import React, { useState } from "react";
import { Link, useNavigate } from "react-router";
import { Button, Card, Image, OverlayTrigger } from "react-bootstrap";
import { NAVIGATIONS } from "../../";
import { ProductInfo } from "../../constants/products";
import WorkingCapitalRegistrationModal from "./working-capital-registration-modal";
import { Tooltip } from "react-bootstrap";
import { ENV } from "../../config/env";

interface IProps {
  product: ProductInfo;
  onRegisterCapitalLoan?: () => void;
  short?: boolean;
  onClickCard?: () => void;
  onNavigate?: () => void;
}

function ProductCard({
  product,
  onRegisterCapitalLoan,
  short = false,
  onClickCard,
  onNavigate,
}: IProps) {
  const navigate = useNavigate();
  const [registerCapitalLoan, setRegisterCapitalLoan] = useState(false);
  const handleRegister = () => {
    let link = product.link;
    if (!product) {
      return null;
    }
    if (product.key === "contact") {
      navigate(NAVIGATIONS.contact);
      return null;
    }
    if (product.link === "") {
      return null;
    }
    if (ENV.V2_PRODUCTS.includes(product.key)) {
      link = link + "?form=register";
    }
    if (product.key === "capitalLoan") {
      if (ENV.V2_PRODUCTS.includes("capitalLoan")) {
        window.open(link, "_blank");
        return;
      }
      if (onRegisterCapitalLoan) {
        onRegisterCapitalLoan();
      } else {
        setRegisterCapitalLoan(true);
      }
      return;
    }
    window.open(link, "_blank");
  };
  const handleClickCard = () => {
    if (onClickCard) {
      navigate(NAVIGATIONS[product.key]);
      onClickCard();
    }
    return;
  };
  const handleClickLink = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <React.Fragment>
      <Card
        className={`h-100 card-hover ${onClickCard ? "cursor-pointer" : ""}`}
        onClick={handleClickCard}
      >
        <Card.Body className="p-0">
          <div className="d-flex h-100 justify-content-between">
            <div className="py-4 ps-4 pe-2 d-flex flex-column justify-content-between">
              <div>
                <div className="fw-bold text-size-body-head-2 text-primary-main">
                  {product.title}
                </div>
                {!short && <div>{product.shortDescription}</div>}
              </div>
              {short ? (
                <div className="mt-4 text-size-caption">
                  <Link
                    to={NAVIGATIONS[product.key]}
                    className="text-secondary"
                    onClick={handleClickLink}
                  >
                    Pelajari lebih lanjut
                  </Link>
                </div>
              ) : (
                <React.Fragment>
                  {product.key === "employeeLoan" ? (
                    <div className="mt-2">
                      <div className="text-size-caption mb-2 fw-bold">
                        Daftar sebagai
                      </div>
                      <div className="mb-2 d-flex d-md-block d-lg-flex align-items-center gap-4">
                        <OverlayTrigger
                          placement="left"
                          overlay={
                            <Tooltip>
                              Pengajuan Employee Loan hanya dapat dilakukan di
                              perusahaan yang telah terdaftar di produk Employee
                              Loan Pohon Dana
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="primary"
                            className="w-100 mb-0 mb-md-2 mb-lg-0"
                            onClick={handleRegister}
                          >
                            Karyawan
                          </Button>
                        </OverlayTrigger>
                        <Button
                          variant="outline-primary"
                          className="w-100"
                          onClick={() => {
                            navigate(NAVIGATIONS.contact);
                            handleClickLink();
                          }}
                        >
                          Perusahaan
                        </Button>
                      </div>
                      {NAVIGATIONS[product.key] && (
                        <div>
                          <Link
                            to={NAVIGATIONS[product.key]}
                            onClick={handleClickLink}
                          >
                            Lihat detail
                          </Link>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="mt-4 d-flex d-md-block d-lg-flex align-items-center">
                      <div className="me-4 mb-0 mb-md-2 mb-lg-0">
                        <Button variant="primary" onClick={handleRegister}>
                          Daftar
                        </Button>
                      </div>
                      {product.key !== "contact" &&
                        NAVIGATIONS[product.key] && (
                          <div>
                            <Link
                              to={NAVIGATIONS[product.key]}
                              onClick={handleClickLink}
                            >
                              Lihat detail
                            </Link>
                          </div>
                        )}
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
            <div className="pe-2 align-self-end">
              <Image src={product.shortImage} fluid />
            </div>
          </div>
        </Card.Body>
      </Card>
      {registerCapitalLoan && (
        <WorkingCapitalRegistrationModal
          onHide={() => setRegisterCapitalLoan(false)}
        />
      )}
    </React.Fragment>
  );
}

export default ProductCard;
